import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader } from '@heroui/react';
import publicService from '../../services/public.service';
import './providers.css';

const Providers = () => {
  const [providers, setProviders] = useState([]);
  const [insurancePlans, setInsurancePlans] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [providersData, plansData] = await Promise.all([
        publicService.getProviders(),
        publicService.getInsurancePlans(),
      ]);
      setProviders(Array.isArray(providersData) ? providersData : []);
      setInsurancePlans(Array.isArray(plansData) ? plansData : []);
    } catch (err) {
      console.error('Error loading public data:', err);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="taasa__providers section__padding" id="providers">
        <div className="text-center">
          <p className="text-gray-600">Loading providers...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="taasa__providers section__padding" id="providers">
      <div className="taasa__providers-heading">
        <h1 className="gradient__text">Our Healthcare Partners</h1>
        <p>Trusted ambulance and healthcare providers across the region</p>
      </div>
      <div className="taasa__providers-container">
        {providers.length > 0 ? (
          providers.slice(0, 6).map((provider) => (
            <div key={provider.id} className="taasa__providers-container_provider">
              <div className="taasa__providers-container_provider-title">
                <h3>{provider.name}</h3>
              </div>
              <div className="taasa__providers-container_provider-text">
                <p>{provider.contactEmail}</p>
                <p className="text-sm text-gray-500">License: {provider.licenseNumber}</p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-600">No providers available at this time.</p>
        )}
      </div>
    </div>
  );
};

export default Providers;
